/* eslint-disable no-restricted-globals */
// @flow strict

export default {
  copy: (content: string) => {
    let successful = false;
    const { body } = document;
    const selection = document.getSelection();
    let mark;
    try {
      if (body && selection) {
        const range = document.createRange();
        mark = document.createElement('span');
        mark.textContent = content;
        body.appendChild(mark);
        range.selectNode(mark);
        selection.removeAllRanges();
        selection.addRange(range);
        successful = document.execCommand('copy');
      }
    } finally {
      if (selection) {
        selection.removeAllRanges();
      }

      if (mark && body) {
        body.removeChild(mark);
      }
    }
    return successful;
  },
};
